// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'"},"className":"__className_a76515"};